import { createTypes, createAction } from 'lib/action'

const LOAD_MASTERDATA_SUBLOCATION = createTypes('masterdatasublocation', 'load')
const CREATE_MASTERDATA_SUBLOCATION = createTypes(
  'masterdatasublocation',
  'create',
)
const UPDATE_MASTERDATA_SUBLOCATION = createTypes(
  'masterdatasublocation',
  'update',
)
const EXPORT_MASTERDATA_SUBLOCATION = createTypes(
  'exportmasterdatasublocation',
  'load',
)

const loadSubLocation = {
  request: (data, loading) =>
    createAction(LOAD_MASTERDATA_SUBLOCATION.REQUEST, { data, loading }),
  success: lists =>
    createAction(LOAD_MASTERDATA_SUBLOCATION.SUCCESS, {
      lists,
    }),
  failure: () => createAction(LOAD_MASTERDATA_SUBLOCATION.FAITLURE),
}

const createMasterDataSubLocation = {
  request: (data, loading) =>
    createAction(CREATE_MASTERDATA_SUBLOCATION.REQUEST, { data, loading }),
  success: res =>
    createAction(CREATE_MASTERDATA_SUBLOCATION.SUCCESS, { res }),
  failure: () => createAction(CREATE_MASTERDATA_SUBLOCATION.FAILURE),
}

const updateMasterDataSubLocation = {
  request: (data, loading) =>
    createAction(UPDATE_MASTERDATA_SUBLOCATION.REQUEST, { data, loading }),
  success: res =>
    createAction(UPDATE_MASTERDATA_SUBLOCATION.SUCCESS, { res }),
  failure: () => createAction(UPDATE_MASTERDATA_SUBLOCATION.FAILURE),
}

const exportSubLocation = {
  request: (data, loading) =>
    createAction(EXPORT_MASTERDATA_SUBLOCATION.REQUEST, { data, loading }),
  success: res =>
    createAction(EXPORT_MASTERDATA_SUBLOCATION.SUCCESS, { res }),
  failure: () => createAction(EXPORT_MASTERDATA_SUBLOCATION.FAILURE),
}

export {
  LOAD_MASTERDATA_SUBLOCATION,
  loadSubLocation,
  CREATE_MASTERDATA_SUBLOCATION,
  createMasterDataSubLocation,
  UPDATE_MASTERDATA_SUBLOCATION,
  updateMasterDataSubLocation,
  EXPORT_MASTERDATA_SUBLOCATION,
  exportSubLocation,
}
